import React from "react";
import { addToast, removeToast } from "actions/snackbar";

const SUCCESS_ICON = "check_circle";
const ERROR_ICON = "error";
const WARNING_ICON = "warning";

const getToastMessage = content => {
  if (Array.isArray(content)) {
    return content.map((item, key) => {
      return <span key={key}>{item}<br /></span>;
    });
  }
  else return content;
};

export default {
  success(content, dispatch, autohide = true) {
    return dispatch(addToast({
      toast: {
        text: <span><i className="md-icon material-icons toast-icon">{SUCCESS_ICON}</i> {getToastMessage(content)}</span>,
        action: "X"
      },
      type: "success",
      autohide: autohide
    }));
  },

  clientErrors(errors, dispatch, autohide = true) {
    return dispatch(addToast({
      toast: {
        text: <span><i className="md-icon material-icons toast-icon">{ERROR_ICON}</i> {getToastMessage(errors)}</span>,
        action: "X"
      },
      type: "error",
      autohide: autohide
    }));
  },

  error(response, dispatch, autohide = true) {
    switch (response.status) {
      case 400:
      case 401:
        response.json().then((data) => {
          if (data.errors && data.errors.length) {
            // display the errors from our API.
            data.errors.map(error => {
              if (error.message.length) {
                dispatch(addToast({
                  toast: {
                    text: <span><i className="md-icon material-icons toast-icon">{ERROR_ICON}</i> {error.message.split("\n").map((item, key) => {
                      return <span key={key}>{item}<br /></span>;
                    })}</span>,
                    action: "X"
                  },
                  type: "error",
                  autohide: autohide,
                }));
              }
            });
          } else {
            // make a better piece of toast
            dispatch(addToast({
              toast: {
                text: <span><i className="md-icon material-icons toast-icon">{ERROR_ICON}</i> Oops! {data.message || data}</span>,
                action: "X"
              },
              type: "error",
              autohide: autohide,
            }));
          }
        });
        break;
      default:
        return dispatch(addToast({
          toast: {
            text: <span><i className="md-icon material-icons toast-icon">{ERROR_ICON}</i> Oops! Something went wrong. Please try again.</span>,
            action: "X",
          },
          type: "error",
          autohide: autohide,
        }));
    }
  },

  warning(content, dispatch, autohide = true) {
    return dispatch(addToast({
      toast: {
        text: <span><i className="md-icon material-icons toast-icon">{WARNING_ICON}</i> {getToastMessage(content)}</span>,
        action: "X"
      },
      type: "warning",
      autohide: autohide
    }));
  },

  customToast(content, type, dispatch) {
    switch (type) {
      case "success":
        return this.success(content, dispatch);
      case "warning":
        return this.warning(content, dispatch);
      case "error":
        if (typeof content === "object") {
          return this.error(content, dispatch);
        } else {
          let errors = content;
          if (typeof content === "string") {
            errors = [content];
          } 
          return this.clientErrors(errors, dispatch);
        }
      default:
        return dispatch(addToast({
          toast: {
            text: content,
            action: "X"
          },
          type: type,
          autohide: true,
        }));
    }
  },

  noHideCustomToast(content, type, dispatch) {
    switch (type) {
      case "success":
        return this.success(content, dispatch, false);
      case "warning":
        return this.warning(content, dispatch, false);
      case "error":
        if (typeof content === "object") {
          return this.error(content, dispatch, false);
        } else {
          let errors = content;
          if (typeof content === "string") {
            errors = [content];
          } 
          return this.clientErrors(errors, dispatch, false);
        }
      default:
        return dispatch(addToast({
          toast: {
            text: content,
            action: "X"
          },
          type: type,
          autohide: false,
        }));
    }
  },

  removeToast(dispatch) {
    return dispatch(removeToast());
  },
};


